import { createContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface NavigationContextValue {
  inline: boolean;
}

export const NavigationContext = createContext<NavigationContextValue>({
  inline: false,
});
